var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-factors-actions" },
    [
      _vm.record.comment.length > 0
        ? _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Результат удалённой работы",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Результат удалённой работы',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            staticClass: "main-factors-actions-comment",
            attrs: { size: "iconic", icon: "comment" },
            on: {
              click: function ($event) {
                _vm.isShowCommentModal = true
              },
            },
          })
        : _vm._e(),
      _c("c-button", {
        directives: [
          {
            name: "b-popover",
            rawName: "v-b-popover.html",
            value: {
              container: "#app",
              trigger: "hover blur",
              content: `Сохраненный расчет по филиалу <b>${_vm.record.placeOfWork.value}</b> за <b>${_vm.record.dateTime}</b>`,
              placement: "top",
            },
            expression:
              "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: `Сохраненный расчет по филиалу <b>${record.placeOfWork.value}</b> за <b>${record.dateTime}</b>`,\n      placement: 'top',\n    }",
            modifiers: { html: true },
          },
        ],
        staticClass: "c-table-actions-trash",
        attrs: { size: "iconic", icon: "calculate" },
        on: {
          click: function ($event) {
            return _vm.goToCalculations()
          },
        },
      }),
      _c(
        "b-modal",
        {
          staticClass: "main-factors-actions-comment-modal",
          attrs: {
            id: "main-factors-comment-from-employee",
            centered: "",
            "hide-footer": "",
            "hide-header": "",
          },
          model: {
            value: _vm.isShowCommentModal,
            callback: function ($$v) {
              _vm.isShowCommentModal = $$v
            },
            expression: "isShowCommentModal",
          },
        },
        [
          _c(
            "svg",
            {
              staticClass: "main-factors-actions-comment-modal-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: {
                click: function ($event) {
                  _vm.isShowCommentModal = false
                },
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _vm._v(" " + _vm._s(_vm.record.comment) + " "),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }